/**
 * Replaces values with values provided in object
 */
export function replaceMultipleInString(str: string, mapObj: { [k: string]: string }) {
	if (!mapObj) return str
	if (!str) return ""
	if (Object.keys(mapObj).length == 0) return str
	return str.replace(
		new RegExp(
			// Convert the object to array of keys
			Object.keys(mapObj)
				// Escape any special characters in the search key
				.map((key) => key.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"))
				// Create the Regex pattern
				.join("|"),
			// Additional flags can be used. Like `i` - case-insensitive search
			"g"
		),
		// For each key found, replace with the appropriate value
		(match) => mapObj[match]
	)
}
